<h2 class='requests__headline'>{{ 'request.header' | translate }}</h2>

<mat-tab-group>
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="consultant__topnav-label">
        @if (skillRequestsAmount > 0) {
          <div [matBadge]="skillRequestsAmount" matBadgeOverlap="false"> {{ 'request.tabs.skills'| translate }}</div>
        } @else {
        {{ 'request.tabs.skills'| translate }}
      }
      </span>
    </ng-template>
    <app-request-table [buttonLabel]="'request.buttons.skills'"
                       [type]="RequestType.SKILL"
                       (requestsAmount)='skillRequestsAmount = $event'
                       [tableLabel]="'request.tabs.skills'"
                       [modalDeleteHeader]="'request.modals.skills.deleteHeader'"
                       [modalDeleteLabel]="'request.modals.skills.deleteLabel'"
                       [modalAcceptHeader]="'request.modals.skills.acceptHeader'"
    ></app-request-table>
  </mat-tab>
  <mat-tab [label]="'request.tabs.certificates' | translate">
    <ng-template mat-tab-label>
      <span class="consultant__topnav-label">
        @if (certificatesRequestAmount > 0) {
          <div [matBadge]="certificatesRequestAmount"
               matBadgeOverlap="false"> {{ 'request.tabs.certificates'| translate }}</div>
        } @else {
        {{ 'request.tabs.certificates'| translate }}
      }
      </span>
    </ng-template>
    <app-request-table [buttonLabel]="'request.buttons.certificates'"
                       [type]='RequestType.CERTIFICATE'
                       (requestsAmount)='certificatesRequestAmount = $event'
                       [tableLabel]="'request.tabs.certificates'"
                       [modalEditHeader]="'request.modals.certificates.editHeader'"
                       [modalDeleteHeader]="'request.modals.certificates.deleteHeader'"
                       [modalDeleteLabel]="'request.modals.certificates.deleteLabel'"
                       [modalAcceptHeader]="'request.modals.certificates.acceptHeader'"
                       [modalAcceptLabel]="'request.modals.certificates.acceptLabel'"></app-request-table>
  </mat-tab>
  <mat-tab [label]="'request.tabs.trainings'| translate">
    <ng-template mat-tab-label>
      <span class="consultant__topnav-label">
        @if (trainingsRequestsAmount > 0) {
          <div [matBadge]="trainingsRequestsAmount"
               matBadgeOverlap="false"> {{ 'request.tabs.trainings'| translate }}</div>
        } @else {
        {{ 'request.tabs.trainings'| translate }}
      }
      </span>
    </ng-template>
    <app-request-table [buttonLabel]="'request.buttons.trainings'"
                       [type]='RequestType.TRAINING'
                       [tableLabel]="'request.tabs.trainings'"
                       [modalEditHeader]="'request.modals.trainings.editHeader'"
                       [modalDeleteHeader]="'request.modals.trainings.deleteHeader'"
                       (requestsAmount)='trainingsRequestsAmount = $event'
                       [modalDeleteLabel]="'request.modals.trainings.deleteLabel'"
                       [modalAcceptHeader]="'request.modals.trainings.acceptHeader'"
                       [modalAcceptLabel]="'request.modals.trainings.acceptLabel'"></app-request-table>
  </mat-tab>
  <mat-tab [label]="'request.tabs.mainFocus' | translate">
    <ng-template mat-tab-label>
      <span class="consultant__topnav-label">
        @if (mainFocusRequestsAmount > 0) {
          <div [matBadge]="mainFocusRequestsAmount"
               matBadgeOverlap="false"> {{ 'request.tabs.mainFocus'| translate }}</div>
        } @else {
        {{ 'request.tabs.mainFocus'| translate }}
      }
      </span>
    </ng-template>
    <app-request-table [buttonLabel]="'request.buttons.mainFocus'"
                       [type]='RequestType.MAINFOCUS'
                       [tableLabel]="'request.tabs.mainFocus'"
                       (requestsAmount)='mainFocusRequestsAmount = $event'
                       [modalDeleteHeader]="'request.modals.mainFocus.deleteHeader'"
                       [modalDeleteLabel]="'request.modals.mainFocus.deleteLabel'"
                       [modalAcceptHeader]="'request.modals.mainFocus.acceptHeader'"></app-request-table>
  </mat-tab>
  <mat-tab [label]="'request.tabs.industries' | translate">
    <ng-template mat-tab-label>
      <span class="consultant__topnav-label">
        @if (industriesRequestAmount > 0) {
          <div [matBadge]="industriesRequestAmount"
               matBadgeOverlap="false"> {{ 'request.tabs.industries'| translate }}</div>
        } @else {
        {{ 'request.tabs.industries'| translate }}
      }
      </span>
    </ng-template>
    <app-request-table [buttonLabel]="'request.buttons.industries'"
                       [type]='RequestType.INDUSTRY'
                       [tableLabel]="'request.tabs.industries'"
                       [modalDeleteHeader]="'request.modals.industries.deleteHeader'"
                       [modalDeleteLabel]="'request.modals.industries.deleteLabel'"
                       (requestsAmount)='industriesRequestAmount = $event'
                       [modalAcceptHeader]="'request.modals.industries.acceptHeader'"
    ></app-request-table>
  </mat-tab>
</mat-tab-group>
